import { z } from "zod";

export const RuntimeErrorEventSchema = z.object({
  ts: z.number(),
  logs: z.array(z.string()),
  exceptions: z.array(z.any()), // TraceItem exceptions array
  fetchCall: z
    .object({
      url: z.string(),
      method: z.string(),
    })
    .nullable(),
});

export type RuntimeErrorEvent = z.infer<typeof RuntimeErrorEventSchema>;
